import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { LeadsManagmentComponent } from 'src/app/leads/leads-managment/leads-managment.component';
import { MaterialModule } from 'src/app/material.module';
import { leadServices } from 'src/app/services/leads.service';
import { EventConfirmationDialogComponent } from '../calendar/event-confirmation-dialog/event-confirmation-dialog.component';
import { tasksServices } from 'src/app/services/tasks.service';

@Component({
  selector: 'app-to-do-list',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl : './to-do-list.component.html',
  styleUrls: ['./to-do-list.component.scss']
})
export class ToDoListComponent implements OnInit {
  leadsResponded: any[] = [];
  newLeads: any[] = [];
  todayActivities: any[] = [];

  // Pagination tracking
  leadsRespondedSkip = 0;
  newLeadsSkip = 0;
  todayActivitiesSkip = 0;

  // Total count tracking
  leadsRespondedTotal = 0;
  newLeadsTotal = 0;
  todayActivitiesTotal = 0;

  constructor(
    private leadService: leadServices,
    private dialog: MatDialog,
    private taskService:tasksServices,
    private dialogRef: MatDialogRef<ToDoListComponent>,
    private router: Router,
  ) {}

  async ngOnInit() {
    await this.loadInitialData();
  }

  async loadInitialData() {
    try {
      const response = await firstValueFrom(this.leadService.get({}, 'toDoList'));

      // Load data
      this.leadsResponded = response.leadsResponded.data || [];
      this.newLeads = response.newLeads.data || [];
      this.todayActivities = response.todayActivities.data || [];

      // Set total counts
      this.leadsRespondedTotal = response.leadsResponded.total || 0;
      this.newLeadsTotal = response.newLeads.total || 0;
      this.todayActivitiesTotal = response.todayActivities.total || 0;

      // Set skip values
      this.leadsRespondedSkip = this.leadsResponded.length;
      this.newLeadsSkip = this.newLeads.length;
      this.todayActivitiesSkip = this.todayActivities.length;
    } catch (error) {
      console.error('Error fetching To-Do List:', error);
    }
  }

  async loadMore(type: 'newLeads' | 'leadsResponded' | 'todayActivities') {
    try {
      let skip, updateArray, totalCount;
      if (type === 'newLeads') {
        skip = this.newLeadsSkip;
        updateArray = this.newLeads;
        totalCount = this.newLeadsTotal;
      } else if (type === 'leadsResponded') {
        skip = this.leadsRespondedSkip;
        updateArray = this.leadsResponded;
        totalCount = this.leadsRespondedTotal;
      } else {
        skip = this.todayActivitiesSkip;
        updateArray = this.todayActivities;
        totalCount = this.todayActivitiesTotal;
      }

      // Stop if all data is loaded
      if (skip >= totalCount) return;

      const response = await firstValueFrom(
        this.leadService.get({ type, skip, take: 3 }, 'toDoList')
      );

      if (response.data.length) {
        updateArray.push(...response.data);
        if (type === 'newLeads') this.newLeadsSkip += response.data.length;
        else if (type === 'leadsResponded') this.leadsRespondedSkip += response.data.length;
        else this.todayActivitiesSkip += response.data.length;
      }
    } catch (error) {
      console.error(`Error loading more ${type}:`, error);
    }
  }

  close() {
    this.dialogRef.close();
  }
 

  async redirectToLead(lead: any) {
      const response = await firstValueFrom(
           this.leadService.getOne(lead.id),
         );
   
        this.dialog.open(LeadsManagmentComponent, {
           position: { bottom: '0', right: '0' },
           height: '92vh',
           width: '80%',
           panelClass: 'right-side-dialog',
           enterAnimationDuration: '300ms',
           exitAnimationDuration: '300ms',
           hasBackdrop: true,
           data: { data: response },
         });
  }

  async redirectToTask(task: any) {
    this.router.navigate(['/activities/list'], {
      queryParams: { activity_id: task.id } // Documents tab
    });
  }

  async redirectToMessage(lead: any) {
    const response = await firstValueFrom(
      this.leadService.getOne(lead.id),
    );

    const dialogRef = this.dialog.open(LeadsManagmentComponent, {
      position: { bottom: '0', right: '0' },
      height: '92vh',
      width: '80%',
      panelClass: 'right-side-dialog',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '300ms',
      hasBackdrop: true,
      data: { data: response },
    });
  }
}

